import { FontIcon, Button, FlexWrapper, Text } from '@intigral/shared';
import { useEffect, useState } from 'react';
import { ButtonTypes, COMPONENT_TYPES } from '../../../config/constants';
import { __ } from '../../../translations';
import PlayVideoButton from '../PlayVideoButton';
import { useConfigurationSections } from '../../../hooks/useConfiguration';
export const PurchaseSuccess = ({ tvodInfo, onOverlayClose, content, onPurchase, ...props }) => {
    const durationInHours = 48;
    // Using React Query instead of Redux for configuration
    const { ppvConfig } = useConfigurationSections();
    const ppvList = ppvConfig;
    const [ppvItem, setPPVItem] = useState({});
    let tvodSuccessMsg = __('tvod_purchase_successfull') || '';
    tvodSuccessMsg = tvodSuccessMsg.replace('{durationInHours}', durationInHours);

    // Checks weather this item is in ppv list in appconfig
    useEffect(() => {
        const ppvItem = ppvList?.find((ppv) => ppv?.programId == content?.Id);
        if (ppvItem) {
            setPPVItem(ppvItem);
        }
    }, [ppvList]);

    return (
        <>
            <FlexWrapper flexDirection="column" gap="3x">
                <FontIcon name="exclamation-mark" color="green" size="size60" md="60" />
                <Text as="h2" variant="h2" margin="2x">
                    {tvodSuccessMsg}
                </Text>
                <FlexWrapper flexDirection="row" itemCount="2" gap="4x">
                    <Button
                        secondary
                        onClick={() => {
                            onOverlayClose();
                        }}
                    >
                        {__('tvod_success_close_button')}
                    </Button>
                    <PlayVideoButton
                        buttonType={props?.isPPV ? ButtonTypes.PPVItem : ButtonTypes.VodDetails}
                        item={content}
                        meta={props?.isPPV ? { ppvInfo: ppvItem } : null}
                        componentType={COMPONENT_TYPES.DETAILS_CONTAINER}
                        componentName="PurchaseSuccess"
                    >
                        <Button>
                            {<> {__('play')} </>}
                            <FontIcon name="play-outline" size="small" md="medium" />
                        </Button>
                    </PlayVideoButton>
                </FlexWrapper>
            </FlexWrapper>
        </>
    );
};
